import styled from 'styled-components'

export const StyledHeader = styled.div`
  margin-bottom: 1.5rem;

  a {
    background-image: none;
  }
`
